import * as React from 'react';
window.React = React;
window.ReactJSXRuntime = {
  jsx: React.createElement,
  jsxs: React.createElement,
  Fragment: React.Fragment
};